import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useMemo } from 'react';
import { CustomIcon } from 'shared/components/icon/custom';
import { MoreTime } from '@mui/icons-material';
import { UniversalMenu } from 'shared/components/menu';
import { useDispatch } from 'react-redux';
export const CustomControlMenu = memo(function CustomControlMenu(props) {
    const { anchor, additional_commands, onClose, setMenuItemCount } = props;
    const dispatch = useDispatch();
    const menu_items = additional_commands?.length
        ? additional_commands?.map(({ title, action }) => {
            return {
                label: title,
                show: true,
                icon: _jsx(CustomIcon, { Icon: MoreTime, color: "action" }),
                onClick: () => {
                    dispatch(action());
                    onClose();
                },
            };
        })
        : [];
    const count_showed_elements = useMemo(() => menu_items.filter(({ show }) => !!show).length, [menu_items]);
    useEffect(() => {
        setMenuItemCount(count_showed_elements);
    }, [count_showed_elements]);
    if (count_showed_elements == 0) {
        return null;
    }
    return (_jsx(UniversalMenu, { menu_items: menu_items, opened: !!anchor, anchor: anchor, onClose: onClose }));
});
